import React, { type FC, useState } from 'react';
import _ from 'lodash';
import { cx } from '#packages/util';
import withToolsItems, {
  type ToolsItem,
} from '../hocs/withToolsItems/withToolsItems';

import DropPanelList from '../dropPanel/dropPanelList';

interface ToolsPanelProps {
  items: ToolsItem[];
  closePanel: () => void;
}

const ToolsPanel: FC<ToolsPanelProps> = (props) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  return (
    <DropPanelList
      automationId="top-bar-tools-panel"
      className={cx('tools-panel-content', 'drop-panel-check-list')}
      items={props.items}
      closePanel={props.closePanel}
      onItemHover={setSelectedIndex}
      selectedIndex={selectedIndex}
      isChecklist={false}
      hasDesignPermissions={true}
    />
  );
};

const ConnectedToolsPanel = _.flow(withToolsItems)(ToolsPanel);

ConnectedToolsPanel.pure = ToolsPanel;

export default ConnectedToolsPanel;
